import { ConnectedIntegrationsSchema } from '@weft/types';
import { oz } from '@weft/utils';
import { HomePageInvoiceSummarySchema } from './home-page-invoice-summary-schema';
import { HomePageTopGrossingSchema } from './home-page-top-grossing-schema';
import { HomePageYtdRevenueSchema } from './home-page-ytd-revenue-schema';

export const HomePageDataSchema = oz.object({
  invoicesSummary: HomePageInvoiceSummarySchema,
  ytdRevenue: HomePageYtdRevenueSchema,
  topGrossingPlans: oz.array(HomePageTopGrossingSchema),
  topRevenueChangeCustomers: oz.array(HomePageTopGrossingSchema),
  connectedIntegrations: ConnectedIntegrationsSchema,
}).openapi('HomePageData');

export type HomePageData = oz.infer<typeof HomePageDataSchema>;